import ScrollToTop from "react-scroll-to-top";

export default function Top() {
  return (
    <div>
      
      <ScrollToTop smooth width="40" style={{
        borderRadius:"100%",
        marginBottom:"70px"
    
      }} />
    </div>
  );
}